import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {KMDGameMode} from "../server/KMDGameMode";
import {gsap} from "gsap";

export class KMDReelFrame extends PIXI.Container implements StageLayer {

    private readonly _reelFrame: PIXI.spine.Spine;
    private readonly _reelFrameFS: PIXI.spine.Spine;
    private readonly _reelFrameSFS: PIXI.spine.Spine;
    private readonly _leftSpecialFrame: PIXI.Sprite;
    private readonly _rightSpecialFrame: PIXI.Sprite;
    private _isXBetOn: boolean;

    constructor() {
        super();
        this.name = "KMDReelFrame";

        this._isXBetOn = false;

        this._reelFrame = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("mgReelFrame"));
        this._reelFrame.visible = false;
        this._reelFrameFS = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("fsReelFrame"));
        this._reelFrameFS.visible = false;
        this._reelFrameSFS = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("sfsReelFrame"));
        this._reelFrameSFS.visible = false;

        this._reelFrame.position.set(378, 486);
        this._reelFrameFS.position.set(356, 360);
        this._reelFrameSFS.position.set(356, 432);

        this._leftSpecialFrame = new PIXI.Sprite(KennethMustDie.assetLoader.getTextures("Special_Reel_frame/Special_reel_side_frame")[0]);
        this._rightSpecialFrame = new PIXI.Sprite(KennethMustDie.assetLoader.getTextures("Special_Reel_frame/Special_reel_side_frame")[0]);

        this._leftSpecialFrame.position.set(128, 540);
        this._rightSpecialFrame.position.set(576, 540);

        this.addChild(this._reelFrame, this._reelFrameFS, this._reelFrameSFS, this._leftSpecialFrame, this._rightSpecialFrame);
    }

    public toggleReelFrame(mode: string): void {
        this._reelFrameFS.y = 360;
        this._leftSpecialFrame.y = this._rightSpecialFrame.y = 540;

        if (mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE) {
            this.turnOffOtherReelFrames(this._reelFrame, this._reelFrameSFS);

            this._reelFrameFS.visible = true;
            this._reelFrameFS.updateTransform();
            this._reelFrameFS.skeleton.setToSetupPose();
            this._reelFrameFS.skeleton.setSlotsToSetupPose();
            this._reelFrameFS.state.setAnimation(0, "animation", true);
        } else if (KennethMustDie.model.isRestore && (mode === KMDGameMode.FREESPIN_COOL || mode === KMDGameMode.FREESPIN_COOL_AVALANCHE)) {
            this.turnOffOtherReelFrames(this._reelFrame, this._reelFrameSFS);

            this._leftSpecialFrame.y = this._rightSpecialFrame.y = 545;

            this._reelFrameFS.y = -100;

            this._reelFrameFS.visible = true;
            this._reelFrameFS.updateTransform();
            this._reelFrameFS.state.setAnimation(0, "animation3", true);
        } else if (mode === KMDGameMode.FREESPIN_SUPER || mode === KMDGameMode.FREESPIN_SUPER_AVALANCHE) {
            this.turnOffOtherReelFrames(this._reelFrame, this._reelFrameFS);

            this._reelFrameSFS.visible = true;
            this._reelFrameSFS.updateTransform();
            this._reelFrameSFS.state.setAnimation(0, "animation", true);
        } else {
            this.turnOffOtherReelFrames(this._reelFrameFS, this._reelFrameSFS);

            this._reelFrame.visible = true;
            this._reelFrame.updateTransform();
            this.playMGReelFrameAnimation();
        }
    }

    public fromXBet(isOn: boolean): void {
        this._isXBetOn = isOn;

        this.playMGReelFrameAnimation();
    }

    // #315
    public shake(): void {
        const mode: string = KennethMustDie.model.gameData.mode;
        let animName: string = "shaking";
        if (mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE) {
            animName += "_fs";
        } else if (mode === KMDGameMode.FREESPIN_COOL || mode === KMDGameMode.FREESPIN_COOL_AVALANCHE) {
            animName += "_cfs";
        }

        // #477
        if (mode.indexOf("NORMAL") > -1 && KennethMustDie.useCensor) {
            animName += "_blur";
        }

        this.getVisibleReelFrame().state.setAnimation(0, animName, true);
    }

    // #315
    public stopShake(): void {
        const mode: string = KennethMustDie.model.gameData.mode,
            item: PIXI.spine.Spine = this.getVisibleReelFrame();

        item.state.clearTracks();
        item.skeleton.setToSetupPose();

        if (mode === KMDGameMode.NORMAL || mode === KMDGameMode.NORMAL_AVALANCHE) {
            this.playMGReelFrameAnimation();
        } else {
            let animName: string = "animation";

            if (mode === KMDGameMode.FREESPIN_COOL || mode === KMDGameMode.FREESPIN_COOL_AVALANCHE) {
                animName += "3";
            }

            item.state.setAnimation(0, animName, true);
        }
    }

    public pump(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            item: PIXI.spine.Spine = this.getVisibleReelFrame();

        tl.to(item.scale, {
            duration: duration,
            x: 1.05,
            y: 1.05
        });
        tl.to(item.scale, {
            duration: duration,
            x: 1,
            y: 1
        });

        return tl;
    }

    // #281
    public turnOffForCFS(): void {
        this._leftSpecialFrame.alpha = this._rightSpecialFrame.alpha = 0;

        this.turnOffOtherReelFrames(this._reelFrame, this._reelFrameSFS);

        this._reelFrameFS.visible = true;
        this._reelFrameFS.updateTransform();
        this._reelFrameFS.skeleton.setToSetupPose();
        this._reelFrameFS.skeleton.setSlotsToSetupPose();
        this._reelFrameFS.state.setAnimation(0, "animation", true);
    }

    // #281
    public transitionForCFS(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._reelFrameFS, {
            duration: duration,
            y: -100,
            ease: "none"
        });
        tl.to(this, {
            duration: 0.1
        });

        tl.add([
            () => {
                this._reelFrameFS.state.clearTracks();
            },
            KennethMustDie.createTimelineForAnimation(this._reelFrameFS, 0, "animation2", false).timeScale(0.5)
        ]);

        tl.add(() => {
            this._leftSpecialFrame.y = this._rightSpecialFrame.y = 545;

            this._reelFrameFS.autoUpdate = true;
            this._reelFrameFS.state.setAnimation(0, "animation3", true);
        });

        return tl;
    }

    // #281
    public turnOnForCFS(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to([this._leftSpecialFrame, this._rightSpecialFrame], {
            duration: duration,
            alpha: 1
        });

        return tl;
    }

    private playMGReelFrameAnimation(): void {
        let animName: string = "animation";
        if (this._isXBetOn) {
            animName += "3";
        }

        // #477
        if (KennethMustDie.useCensor) {
            animName += "_blur";
        }

        this._reelFrame.state.setAnimation(0, animName, true);
    }

    private turnOffOtherReelFrames(frame1: PIXI.spine.Spine, frame2: PIXI.spine.Spine): void {
        frame1.visible = false;
        frame1.state.clearTracks();
        frame2.visible = false;
        frame2.state.clearTracks();
    }

    private getVisibleReelFrame(): PIXI.spine.Spine {
        const items: PIXI.spine.Spine[] = [this._reelFrame, this._reelFrameFS, this._reelFrameSFS];

        for (let ctr: number = 0; ctr < items.length; ctr++) {
            if (items[ctr].visible) {
                return items[ctr];
            }
        }

        return items[0];
    }
}